// Packages
import { FC } from 'react'
import clsx from 'clsx'
// Types
import { SubMenu } from '../../constants/type/menu'
import SubMenuItem from './SubMenuItem'
import useAuth from '../../hooks/useAuth'

type IProps = {
  data: SubMenu[]
  isToggle: boolean
  menuId: string
  selectedMenu: string
}

const SubMenuList: FC<IProps> = ({ data, isToggle, menuId, selectedMenu }) => {
  const { user } = useAuth()
  return (
    <ul
      className={clsx(
        'ease-in-out -mt-1 mr-8 text-sm text-gray-400 cursor-pointer',
        menuId === selectedMenu && !isToggle ? 'block' : 'hidden',
      )}
    >
      {data.map((itemMenu: SubMenu) =>
        user?.role.every((role) => itemMenu.subAccessRole.includes(role)) ? (
          <SubMenuItem
            key={itemMenu.key}
            id={itemMenu.id}
            title={itemMenu.title}
            path={itemMenu.path ?? ''}
          />
        ) : null,
      )}
    </ul>
  )
}

export default SubMenuList
